import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import ProductImage from "./ProductImage";

export default function ProductCard({ product, index = 0 }) {
  return (
    <div
      data-testid={`product-card-${product.id}`}
      className="group relative flex flex-col rounded-3xl border border-[#E85D2F]/15 bg-[#121211] overflow-hidden hover:-translate-y-2 hover:border-[#E85D2F]/50 transition-all duration-500 ease-out"
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#F2EEE3]">
        <ProductImage
          product={product}
          sizes="(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <div className="absolute top-4 left-4 z-10">
          <span className="rounded-full bg-[#0A0A09]/70 backdrop-blur text-[#E85D2F] text-[10px] uppercase tracking-[0.2em] px-3 py-1.5 font-semibold border border-[#E85D2F]/20">
            {product.category}
          </span>
        </div>
        <div className="absolute bottom-4 right-4 z-10 font-serif-display italic text-[#0A0A09]/40 text-7xl leading-none select-none">
          {String(index + 1).padStart(2, "0")}
        </div>
      </div>

      <div className="p-7 flex flex-col gap-3 flex-1">
        <p className="font-serif-display italic text-[#E85D2F] text-sm">
          {product.tagline}
        </p>
        <h3 className="font-grotesk text-2xl font-bold tracking-tight text-[#F7F5F0] leading-tight">
          <Link
            to={`/products/${product.id}`}
            data-testid={`product-name-link-${product.id}`}
            className="hover:text-[#E85D2F] transition-colors"
          >
            {product.name}
          </Link>
        </h3>
        <p className="text-sm text-[#F7F5F0]/65 leading-relaxed flex-1">
          {product.description}
        </p>

        <dl className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2 pt-4 border-t border-[#F7F5F0]/10 text-xs">
          <div>
            <dt className="text-[#E85D2F] uppercase tracking-[0.15em] font-semibold text-[10px] mb-1">Ideal use</dt>
            <dd className="text-[#F7F5F0]/80 leading-snug">{product.idealUse}</dd>
          </div>
          <div>
            <dt className="text-[#E85D2F] uppercase tracking-[0.15em] font-semibold text-[10px] mb-1">Material</dt>
            <dd className="text-[#F7F5F0]/80 leading-snug">{product.material}</dd>
          </div>
        </dl>

        <div className="mt-5 flex flex-col sm:flex-row gap-2">
          <Link
            to={`/products/${product.id}`}
            data-testid={`product-view-${product.id}`}
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full bg-[#E85D2F] text-[#0A0A09] px-5 py-3 text-sm font-semibold tracking-wide hover:bg-[#F47A4A] transition-colors"
          >
            View details
            <ArrowUpRight className="h-4 w-4" />
          </Link>
          <Link
            to={`/contact?product=${encodeURIComponent(product.name)}`}
            data-testid={`product-enquire-${product.id}`}
            className="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-[#E85D2F]/40 text-[#E85D2F] px-5 py-3 text-sm font-medium tracking-wide hover:bg-[#E85D2F] hover:text-[#0A0A09] transition-colors"
          >
            Enquire
          </Link>
        </div>
      </div>
    </div>
  );
}
